// -----------------------------------------------------------------------
// Import React and other resources
// -----------------------------------------------------------------------
import React from "react";
import BulkForm from "../../components/BulkForm";

// -----------------------------------------------------------------------
// UnblockSlots Component
// -----------------------------------------------------------------------
class UnblockSlots extends React.Component {
  // -----------------------------------------------------------------------
  // render()
  // -----------------------------------------------------------------------
  render() {
    const { selectedTab, handleTabsChange } = this.props;
    return (
      <React.Fragment>
        <BulkForm
          formFor="unblock-slots"
          showTabs={true}
          selectedTab={selectedTab}
          handleTabsChange={handleTabsChange}
        />
      </React.Fragment>
    );
  }
}

// -----------------------------------------------------------------------
// Export
// -----------------------------------------------------------------------
export default UnblockSlots;
